import React from 'react';

export default ({color = '#72747D'}) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_28067_624)">
      <path
        d="M10.8333 0.833374H18.3333C18.7936 0.833374 19.1667 1.20647 19.1667 1.66671V7.08337C19.1667 7.54362 18.7936 7.91671 18.3333 7.91671H12.5L10 10V1.66671C10 1.20647 10.3731 0.833374 10.8333 0.833374Z"
        stroke={color}
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.99992 15C2.69899 15 0.833252 16.8887 0.833252 19.1667H9.16659C9.16659 16.8887 7.30084 15 4.99992 15Z"
        stroke={color}
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.99984 12.5C6.15043 12.5 7.08317 11.5673 7.08317 10.4167C7.08317 9.26612 6.15043 8.33337 4.99984 8.33337C3.84925 8.33337 2.9165 9.26612 2.9165 10.4167C2.9165 11.5673 3.84925 12.5 4.99984 12.5Z"
        stroke={color}
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.9165 4.58334L14.0739 5.74075L16.6664 3.14807"
        stroke={color}
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_28067_624">
        <rect width="20" height="20" fill="white"/>
      </clipPath>
    </defs>
  </svg>
);
